import { statusIcon } from "./svgIcons";

const GreyBadgeWithIcon = ({
  containerStyle,
  describtion,
  raduis,
  // iconColor,
  // iconName,
  // iconPrefix,
  // iconSize,
}) => {
  return (
    <>
      <div className={`${containerStyle} col-2`}>
        <div
          className="d-flex p-2 align-items-center justify-content-center"
          style={{
            borderRadius: raduis ?? 10,
            backgroundColor: "#F2F2F2",
            fontSize: 14,
          }}
        >
          {statusIcon(describtion?.color, 18, 18)}
          {/* <Icon
            iconPrefix={iconPrefix ?? "fas"}
            name={iconName ?? "cog"}
            color={describtion?.color ?? "#000000"}
            size={iconSize ?? 12}
          /> */}
          <div>{describtion?.name}</div>
        </div>
      </div>
    </>
  );
};

export default GreyBadgeWithIcon;
